webpackJsonp([2],{

/***/ 1558:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1582),
  /* template */
  __webpack_require__(1674),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MedicalAidCard',
  props: {
    value: { required: true, type: Object },
    flat: { type: Boolean, default: true }
  }
});

/***/ }),

/***/ 1578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cards_MedicalAidCard__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cards_MedicalAidCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_cards_MedicalAidCard__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecordCard',
  components: { MedicalAidCard: __WEBPACK_IMPORTED_MODULE_0__components_cards_MedicalAidCard___default.a },
  props: {
    recordId: { required: false },
    value: { type: Object }
  },
  computed: {
    record: function record() {
      if (this.value) {
        return this.value;
      }
    }
  }
});

/***/ }),

/***/ 1580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listitems_GenericListItem__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listitems_GenericListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_listitems_GenericListItem__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ArrayMergePreview',
  components: {
    GenericListItem: __WEBPACK_IMPORTED_MODULE_0__components_listitems_GenericListItem___default.a
  },
  props: {
    value: { type: Array, default: function _default() {
        return [];
      } },
    title: { type: String, default: 'Pick one' },
    itemTitle: { type: String, required: false },
    itemSubTitle: { type: String, required: false },
    loading: { type: Boolean, default: false },
    left: { required: true },
    right: { required: true }
  },
  data: function data() {
    return {
      selected: []
    };
  },

  methods: {
    transfer: function transfer(req, data) {
      req.data = data;
      this.$request('get', req);
    }
  }
});

/***/ }),

/***/ 1581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ObjectSelector',
  props: {
    title: { type: String, default: 'Pick one' },
    sameTitle: { type: String, default: 'Linked object is the same. No action required' },
    value: { type: Object },
    left: { required: true },
    right: { required: true },
    withEdit: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    displayComponent: { type: Object, required: false },
    displayComponentLeftAttrs: { type: Object },
    displayComponentRightAttrs: { type: Object }
  },
  computed: {
    obj: function obj() {
      return this.getObjectPath(this.fieldPath, null);
    }
  },
  methods: {
    isSelected: function isSelected(item) {
      if (this.value && this.value.id === item.id) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),

/***/ 1582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ObjectSelector__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ObjectSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ObjectSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArrayMergePreview__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArrayMergePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ArrayMergePreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_RelationshipPicker__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pickers_RelationshipPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pickers_RelationshipPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_RecordCard__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_RecordCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cards_RecordCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lists_SpaceFaces__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lists_SpaceFaces___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_lists_SpaceFaces__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_client_ClientListItem_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_client_ClientListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_client_ClientListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_client_forms_ShareForm_vue__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_client_forms_ShareForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_client_forms_ShareForm_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MergeClients',
  components: {
    ObjectSelector: __WEBPACK_IMPORTED_MODULE_1__ObjectSelector___default.a,
    ArrayMergePreview: __WEBPACK_IMPORTED_MODULE_2__ArrayMergePreview___default.a,
    RelationshipPicker: __WEBPACK_IMPORTED_MODULE_3__components_pickers_RelationshipPicker___default.a,
    SpaceFaces: __WEBPACK_IMPORTED_MODULE_5__components_lists_SpaceFaces___default.a,
    RecordCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_RecordCard___default.a,
    ClientListItem: __WEBPACK_IMPORTED_MODULE_6__components_client_ClientListItem_vue___default.a,
    ShareForm: __WEBPACK_IMPORTED_MODULE_7__components_client_forms_ShareForm_vue___default.a
  },
  props: {
    relationshipId: { required: false }
  },
  data: function data() {
    return {
      left: null,
      right: null,
      reqId: 'get-comparison-req',
      merge: {
        owner: {},
        record: null,
        client: null
      },
      adminoverride: {
        leftId: null,
        rightId: null
      },
      crumbs: [{
        text: 'Clients',
        disabled: false,
        to: '/clients',
        exact: true
      }],
      requests: {
        delete: {
          resource: 'ag.clients'
        },
        transfer: {
          appts: {
            resource: 'ag.practitioner.appointments',
            extra: 'actions/bulk_transfer_appointments'
          },
          notes: {
            resource: 'metadataguru.notes',
            extra: 'actions/transfer_client'
          },
          invs: {
            resource: 'invoiceguru.invoices',
            extra: 'transfer_invoices'
          }
        }
      },
      isDirty: true,
      personComponent: __WEBPACK_IMPORTED_MODULE_6__components_client_ClientListItem_vue___default.a,
      recordComponent: __WEBPACK_IMPORTED_MODULE_4__components_cards_RecordCard___default.a
    };
  },

  computed: {
    clientdiff: function clientdiff() {
      return this.getObjectPath(this.comparisonRequest, 'result.data.diff', {});
    },
    leftDetail: function leftDetail() {
      return this.getObjectPath(this.comparisonRequest, 'result.data.r1', {});
    },
    rightDetail: function rightDetail() {
      return this.getObjectPath(this.comparisonRequest, 'result.data.r2', {});
    },
    leftRecord: function leftRecord() {
      if (this.leftDetail && this.leftDetail.record && this.leftDetail.record.length === 2) {
        return this.leftDetail.record[0];
      }
    },
    rightRecord: function rightRecord() {
      if (this.rightDetail && this.rightDetail.record && this.rightDetail.record.length === 2) {
        return this.rightDetail.record[0];
      }
    },
    leftRightString: function leftRightString() {
      var str = '';
      if (this.left) {
        str += this.left.id;
      }
      if (this.right) {
        str += this.right.id;
      }
      return str;
    },
    comparisonRequest: function comparisonRequest() {
      return this.$store.getters.getRequestById(this.reqId, true);
    },
    comparisonRequestStatus: function comparisonRequestStatus() {
      return this.comparisonRequest.status;
    },
    deleteRequestStatus: function deleteRequestStatus() {
      return this.requests.delete.status;
    },
    comparisonParams: function comparisonParams() {
      if (this.left && this.right) {
        var params = {
          'r1': this.left.id,
          'r2': this.right.id
        };
        return params;
      }
    },
    canCompare: function canCompare() {
      if (this.adminoverride.leftId && this.adminoverride.rightId) {
        return true;
      }
      if (!this.left || !this.right) {
        return false;
      }
      if (this.left.id === this.right.id) {
        return false;
      }
      return true;
    },
    allTransferReqs: function allTransferReqs() {
      return [this.requests.transfer.appts.status, this.requests.transfer.notes.status, this.requests.transfer.invs.status];
    }
  },
  watch: {
    leftRightString: function leftRightString() {
      this.isDirty = true;
    },
    comparisonRequestStatus: function comparisonRequestStatus() {
      if (this.comparisonRequestStatus === 200) {
        this.isDirty = false;
      }
    },
    allTransferReqs: function allTransferReqs() {
      if (this.allTransferReqs.indexOf(200) !== -1) {
        this.compare();
      }
    },
    deleteRequestStatus: function deleteRequestStatus() {
      if (this.deleteRequestStatus === 204) {
        this.right = null;
      }
    }
  },
  methods: {
    setLeft: function setLeft(client) {
      this.left = client;
    },
    setRight: function setRight(client) {
      this.right = client;
    },
    startMerge: function startMerge() {},
    swap: function swap(left, right) {
      var lcopy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(left));
      var rcopy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(right));
      this.left = rcopy;
      this.right = lcopy;
      this.compare();
    },
    transferInvoices: function transferInvoices(selected) {
      this.requests.transfer.invs.data = {
        invoices: selected.join(','),
        transfer_to_relationship: this.left.id
      };
      this.$request('save', this.requests.transfer.invs);
    },
    transferAppts: function transferAppts(selected) {
      this.requests.transfer.appts.data = {
        appointments: selected.join(','),
        transfer_to_relationship: this.left.id
      };
      this.$request('save', this.requests.transfer.appts);
    },
    transferNotes: function transferNotes(selected) {
      this.requests.transfer.notes.data = {
        notes: selected.join(','),
        transfer_to_relationship: this.left.id
      };
      this.$request('save', this.requests.transfer.notes);
    },
    archive: function archive(relationshipId) {
      this.requests.delete.resourceId = relationshipId;
      this.$request('delete', this.requests.delete);
    },
    compare: function compare() {
      var params = null;
      if (this.left && this.right) {
        params = {
          r1: this.left.id,
          r2: this.right.id
        };
      }
      if (this.adminoverride.leftId && this.adminoverride.rightId) {
        params = {
          r1: this.adminoverride.leftId,
          r2: this.adminoverride.rightId
        };
      }
      if (params) {
        this.$appointmentguru.resource('client.v2.compare').id(this.reqId).list(params);
      }
    }
  }
});

/***/ }),

/***/ 1584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GenericListItem',
  props: {
    value: { type: Object, required: true },
    itemTitle: { type: String, required: false },
    itemSubTitle: { type: String, required: false },
    title: { type: String, required: false },
    withId: { type: Boolean, default: false }
  },
  computed: {
    titleText: function titleText() {
      if (this.title) {
        return this.title;
      }
      if (typeof this.value === 'string') {
        return this.value;
      }
      if (this.itemTitle) {
        return this.getObjectPath(this.value, this.itemTitle);
      }
      return this.value.title || this.value.name || this.value.id || this.value;
    },
    subTitleText: function subTitleText() {
      if (this.itemSubTitle) {
        return this.getObjectPath(this.value, this.itemSubTitle);
      }
      return null;
    }
  }
});

/***/ }),

/***/ 1623:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1577),
  /* template */
  __webpack_require__(1650),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1624:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1578),
  /* template */
  __webpack_require__(1651),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1626:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1580),
  /* template */
  __webpack_require__(1647),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1627:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1581),
  /* template */
  __webpack_require__(1671),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1629:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1584),
  /* template */
  __webpack_require__(1662),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1647:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-4"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.left) ? _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "top": "",
      "right": "",
      "small": "",
      "color": "info"
    },
    domProps: {
      "textContent": _vm._s(_vm.left.length)
    }
  }), _vm._v(" "), (_vm.left.length > 0) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.left), function(item, index) {
    return [_c('generic-list-item', {
      key: item.id,
      attrs: {
        "with-id": "",
        "item-title": _vm.itemTitle,
        "item-sub-title": _vm.itemSubTitle
      },
      model: {
        value: (_vm.left[index]),
        callback: function($$v) {
          _vm.$set(_vm.left, index, $$v)
        },
        expression: "left[index]"
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (item.id))
    })]
  })], 2) : _c('v-subheader', {
    staticClass: "pa-3"
  }, [_vm._v("No items to merge")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.right) ? _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "top": "",
      "right": "",
      "small": "",
      "color": "info"
    },
    domProps: {
      "textContent": _vm._s(_vm.right.length)
    }
  }), _vm._v(" "), (_vm.right.length > 0) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.right), function(item, index) {
    return [_c('generic-list-item', {
      key: item.id,
      attrs: {
        "with-id": "",
        "item-title": _vm.itemTitle,
        "item-sub-title": _vm.itemSubTitle
      },
      model: {
        value: (_vm.right[index]),
        callback: function($$v) {
          _vm.$set(_vm.right, index, $$v)
        },
        expression: "right[index]"
      }
    }, [_c('v-list-tile-action', {
      attrs: {
        "slot": "action"
      },
      slot: "action"
    }, [_c('v-checkbox', {
      attrs: {
        "value": item.id
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (item.id))
    })]
  })], 2) : _c('v-subheader', {
    staticClass: "pa-3"
  }, [_vm._v("No items to merge")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.selected.length === 0,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("transfer", _vm.selected)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_backspace")]), _vm._v("\n            Transfer " + _vm._s(_vm.selected.length) + " items\n          ")], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1650:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('v-card-title', {
    staticClass: "overline pb-0"
  }, [_vm._v("\n    Medical Aid details\n  ")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.value.name || 'scheme unknown'))]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text--primary"
  }, [_vm._v("\n          " + _vm._s(_vm.value.patient_first_name) + " " + _vm._s(_vm.value.patient_last_name) + "\n        ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("# " + _vm._s(_vm.value.number || 'no membership number'))])], 1)], 1), _vm._v(" "), (_vm.value.is_dependent === true) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Main member")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text--primary"
  }, [_vm._v(_vm._s(_vm.value.member_first_name) + " " + _vm._s(_vm.value.member_last_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          ID: " + _vm._s(_vm.value.main_member_id_number || 'unknown') + "\n        ")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1651:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(_vm.record) ? _c('v-card-title', {
    staticClass: "pb-0 overline"
  }, [_vm._v("\n    #" + _vm._s(_vm.record.id) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [(_vm.record && _vm.record.patient) ? _c('div', [_vm._v("\n      Billing address: " + _vm._s(_vm.record.patient.billing_address || 'n/a')), _c('br'), _vm._v("\n      Birthday: " + _vm._s(_vm.record.patient.date_of_birth)), _c('br')]) : _vm._e()])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.record.medical_aid) ? _c('medical-aid-card', {
    model: {
      value: (_vm.record.medical_aid),
      callback: function($$v) {
        _vm.$set(_vm.record, "medical_aid", $$v)
      },
      expression: "record.medical_aid"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1662:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.value)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.value && _vm.withId) ? _c('span', [_vm._v("#" + _vm._s(_vm.value.id))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.titleText) + "\n    ")]), _vm._v(" "), _vm._t("sub-title", function() {
    return [(_vm.subTitleText) ? _c('v-list-tile-sub-title', [_vm._v("\n        " + _vm._s(_vm.subTitleText) + "\n      ")]) : _vm._e()]
  })], 2), _vm._v(" "), _vm._t("action")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1671:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-card-title', {
    staticClass: "overline",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("alert"), _vm._v(" "), (_vm.left.id === _vm.right.id) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "success",
      "color": "success"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.sameTitle) + "\n  ")]) : _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.left) ? _c('v-card', {
    staticClass: "ma-3",
    on: {
      "click": function($event) {
        return _vm.$emit("input", _vm.left)
      }
    }
  }, [_vm._t("left-title"), _vm._v(" "), _vm._t("left-object", function() {
    return [(_vm.displayComponent) ? _c(_vm.displayComponent, _vm._b({
      tag: "component"
    }, 'component', _vm.displayComponentLeftAttrs, false)) : _c('pre', [_vm._v("              " + _vm._s(_vm.left) + "\n            ")])]
  }), _vm._v(" "), (_vm.withEdit) ? _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "fab": "",
      "absolute": "",
      "top": "",
      "right": "",
      "small": "",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.$emit("edit", _vm.left)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), (_vm.right) ? _c('v-flex', {
    attrs: {
      "xs16": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-3",
    on: {
      "click": function($event) {
        return _vm.$emit("input", _vm.right)
      }
    }
  }, [_vm._t("right-object", function() {
    return [(_vm.displayComponent) ? _c(_vm.displayComponent, _vm._b({
      tag: "component",
      staticClass: "ma-0"
    }, 'component', _vm.displayComponentRightAttrs, false)) : _c('pre', [_vm._v("              " + _vm._s(_vm.right) + "\n            ")])]
  })], 2)], 1) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1674:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-3",
    attrs: {
      "full-width": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n        Merge clients\n        "), _c('v-spacer'), _vm._v(" "), _c('v-icon', [_vm._v("merge_type")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": true,
      "type": "info",
      "dismissible": ""
    }
  }, [_c('h3', {
    staticClass: "subheading"
  }, [_vm._v("Before you start:")]), _vm._v(" "), _c('li', [_vm._v("Merging should be performed by a "), _c('strong', [_vm._v("practice owner")])]), _vm._v(" "), _c('li', [_vm._v("If you are marging clients owned by a different practitioner, make sure they have "), _c('strong', [_vm._v("shared them with a space that you own")])]), _vm._v(" "), _c('h3', {
    staticClass: "subheading mt-2"
  }, [_vm._v("How it works:")]), _vm._v(" "), _c('li', [_vm._v("Select two clients. One that you would like to keep, and one that you would like to remove.")]), _vm._v(" "), _c('li', [_vm._v("We'll load all the information for each client")]), _vm._v(" "), _c('li', [_vm._v("Read through the information and transfer relevant information from the client you woud like to delete to the client that you are keeping")]), _vm._v(" "), _c('li', [_vm._v("Once you've moved all the information, you can safely delete the empty client")])]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              1./ The client that you would like to "), _c('strong', {
    staticClass: "ml-1"
  }, [_vm._v("keep")])]), _vm._v(" "), _c('relationship-picker', {
    staticClass: "mx-2",
    attrs: {
      "multiple": false
    },
    on: {
      "selected": _vm.setLeft
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.left && _vm.left.id) ? _c('client-list-item', {
    attrs: {
      "show-spaces": "",
      "with-details": "",
      "owner": _vm.left.practitioner_id,
      "spaces": _vm.left.spaces,
      "with-action": false,
      "relationship-id": _vm.left.id,
      "client": _vm.left
    },
    model: {
      value: (_vm.relationshipId),
      callback: function($$v) {
        _vm.relationshipId = $$v
      },
      expression: "relationshipId"
    }
  }, [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "slot": "after-title",
      "outline": "",
      "label": ""
    },
    slot: "after-title"
  }, [_vm._v("#" + _vm._s(_vm.left.id))])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-center pt-5",
    attrs: {
      "xs2": ""
    }
  }, [_c('center', [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": !_vm.left || !_vm.right
    },
    on: {
      "click": function($event) {
        return _vm.swap(_vm.left, _vm.right)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")]), _vm._v("\n              swap\n              "), _c('v-icon', [_vm._v("chevron_right")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              2./ The client that you would like to "), _c('strong', {
    staticClass: "ml-1"
  }, [_vm._v("remove")])]), _vm._v(" "), _c('relationship-picker', {
    staticClass: "mx-2",
    attrs: {
      "multiple": false
    },
    on: {
      "input": function($event) {
        _vm.requests.delete.status = 0
      },
      "selected": _vm.setRight
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.right && _vm.right.id) ? _c('client-list-item', {
    attrs: {
      "show-spaces": "",
      "with-details": "",
      "owner": _vm.right.practitioner_id,
      "spaces": _vm.right.spaces,
      "with-action": false,
      "relationship-id": _vm.right.id,
      "client": _vm.right
    }
  }, [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "slot": "after-title",
      "outline": "",
      "label": ""
    },
    slot: "after-title"
  }, [_vm._v("#" + _vm._s(_vm.right.id))])], 1) : _vm._e(), _vm._v(" "), (_vm.deleteRequestStatus === 204) ? _c('v-alert', {
    staticClass: "ma-0",
    attrs: {
      "tile": "",
      "dismissible": "",
      "value": true,
      "type": "success"
    }
  }, [_vm._v("\n              Client has successfully been removed\n            ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.left && _vm.right && (_vm.left.id === _vm.right.id)) ? _c('span', {
    staticClass: "ml-3 red--text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "error"
    }
  }, [_vm._v("warning")]), _vm._v("\n          these are the same users\n        ")], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "loading": _vm.comparisonRequest.loading,
      "disabled": !_vm.canCompare,
      "color": "primary"
    },
    on: {
      "click": _vm.compare
    }
  }, [_vm._v("Compare")])], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.comparisonRequest,
      "message403": "You do not have the required permissions for one of these users. Please ensure that you are the owner of both clients, or that the client is shared in a space which you own"
    }
  })], 1)], 1), _vm._v(" "), (_vm.right && _vm.leftDetail && _vm.rightDetail && !_vm.isDirty) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-3 pb-5 mx-3"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        Merge options:\n      ")]), _vm._v(" "), _c('v-card-text', {
    attrs: {
      "color": "gray lighten-4"
    }
  }, [_c('v-divider'), _vm._v(" "), (_vm.leftRecord && _vm.rightRecord) ? [_c('object-selector', {
    staticClass: "mt-3",
    attrs: {
      "with-edit": "",
      "title": "Choose details",
      "same-title": "Details are the same",
      "left": _vm.leftRecord,
      "right": _vm.rightRecord,
      "display-component": _vm.recordComponent,
      "display-component-left-attrs": {
        value: _vm.leftRecord
      },
      "display-component-right-attrs": {
        value: _vm.rightRecord
      }
    },
    on: {
      "edit": function($event) {
        return _vm.launchCustomerDetailsDialog(_vm.left.id)
      }
    },
    model: {
      value: (_vm.merge.record),
      callback: function($$v) {
        _vm.$set(_vm.merge, "record", $$v)
      },
      expression: "merge.record"
    }
  }, [_c('v-alert', {
    attrs: {
      "slot": "alert",
      "value": true,
      "type": "info"
    },
    slot: "alert"
  }, [_vm._v("\n              We will keep the record on the left. You can edit it if values on the right are more recent\n            ")])], 1)] : _vm._e()], 2)], 1), _vm._v(" "), (_vm.rightDetail && _vm.rightDetail.appointments && _vm.leftDetail && _vm.leftDetail.appointments) ? [_c('array-merge-preview', {
    staticClass: "ma-3",
    attrs: {
      "title": "Appointments",
      "loading": _vm.requests.transfer.appts.loading || _vm.comparisonRequest.loading,
      "left": _vm.leftDetail.appointments,
      "right": _vm.rightDetail.appointments,
      "item-title": "title",
      "item-sub-title": "start_time"
    },
    on: {
      "transfer": _vm.transferAppts
    }
  })] : _vm._e(), _vm._v(" "), (_vm.rightDetail && _vm.rightDetail.notes && _vm.leftDetail && _vm.leftDetail.notes) ? [_c('array-merge-preview', {
    staticClass: "ma-3",
    attrs: {
      "title": "notes",
      "loading": _vm.requests.transfer.notes.loading || _vm.comparisonRequest.loading,
      "left": _vm.leftDetail.notes,
      "right": _vm.rightDetail.notes,
      "item-title": "title",
      "item-sub-title": "start_time"
    },
    on: {
      "transfer": _vm.transferNotes
    }
  }, [_c('v-alert', {
    staticClass: "ma-0",
    attrs: {
      "type": "info",
      "value": true,
      "tile": ""
    }
  }, [_vm._v("\n          We can only show you notes to which you have access.\n          Please ensure that any team members\n          who may have have created notes\n          has shared them with an appropriate space\n        ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.rightDetail && _vm.rightDetail.invoices && _vm.rightDetail.invoices.results && _vm.leftDetail && _vm.leftDetail.invoices && _vm.leftDetail.invoices.results) ? [_c('array-merge-preview', {
    staticClass: "ma-3",
    attrs: {
      "title": "invoices",
      "loading": _vm.requests.transfer.invs.loading || _vm.comparisonRequest.loading,
      "left": _vm.leftDetail.invoices.results,
      "right": _vm.rightDetail.invoices.results,
      "item-title": "title",
      "item-sub-title": "start_time"
    },
    on: {
      "transfer": _vm.transferInvoices
    }
  })] : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.delete
    }
  }), _vm._v(" "), (_vm.right && _vm.right.id) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.delete.loading,
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.archive(_vm.right.id)
      }
    }
  }, [_vm._v("Archive right hand user")])], 1) : _vm._e()], 1)], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.30856004bc4003423de0.js